import { getFeatureFlagsPath } from 'api/FeatureFlags/apiPaths';
import axios from 'api/axios';
export var getFeatureFlagsGetRequest = function getFeatureFlagsGetRequest() {
    return axios.get(getFeatureFlagsPath());
};
